import { useCallback, useState } from "react";

import { loadDateFormat, saveDateFormat, type DateFormatMode } from "@/lib/dateFormat";

// The user's due-date display preference ("relative" vs "absolute"), persisted per
// browser and shared across boards + views. Mirrors useDetailViewMode: no cross-route
// live sync is needed — the setting is changed on /settings, and each board surface
// re-reads it on its next mount.
export function useDateFormat() {
  const [mode, setModeState] = useState<DateFormatMode>(loadDateFormat);
  const setMode = useCallback((m: DateFormatMode) => {
    setModeState(m);
    saveDateFormat(m);
  }, []);
  return [mode, setMode] as const;
}
